<div
    *ngIf="block | async as block"
    class="survey-element surveys-render-survey"
    [class.enabled-margin-disclaimer]="shouldMarginDisclaimerWhenShowBlockHeader"
>
    <surveys-survey-block
        [block]="block"
        [elements]="visibleElements | async"
        (shouldMarginDisclaimerWhenShowBlockHeader)="shouldMarginDisclaimerWhenShowBlockHeader = $event"
        ></surveys-survey-block>
    <surveys-element-disclaimer></surveys-element-disclaimer>
    <surveys-element-content-id [contentId]="block.contentId"></surveys-element-content-id>
</div>
